export default __webpack_public_path__ + "static/media/pickMeals.93b1475e.svg";